import React from 'react';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {PlayArrow, YouTube} from '@mui/icons-material';
import styled from 'styled-components';

const DEFAULT_ICON_SIZE = 18;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.background ?? COLORS.white};
  border-radius: 50%;
  width: 100%;
  height: 100%;
  font-size: ${SIZES[DEFAULT_ICON_SIZE]};
`;

const YoutubeInRed = styled(YouTube)`
  color: #ff0000;
`;

export const getTeaserIcon = key => {
  switch (key) {
    case 'SPORT.VIDEO':
      return (
        <IconContainer>
          <img width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} src='/sportvideo.svg' alt='Sport.Video' />
        </IconContainer>
      );
    case 'YouTube':
      return (
        <IconContainer>
          <YoutubeInRed />
        </IconContainer>
      );
    case 'Staige':
      return (
        <IconContainer>
          <img width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} src='/staige.svg' alt='Staige' />
        </IconContainer>
      );
    default:
      return (
        <IconContainer background={COLORS.lightBlue}>
          <PlayArrow color='icon-invert' fontSize='inherit' />
        </IconContainer>
      );
  }
};
